import {raise} from '@yandex-delivery/utils'

import type {TariffsCountry, TariffsZone, TariffsZones, TariffsZonesInfo} from '../../../model/tariffs'
import type {TariffZonesResponse, ZoneItem} from '../../../repo/tariffs'

export function toTariffsZonesInfo({
  countries: countriesWithZones,
  default_country: defaultCountryRepo, // Надо обновить типы
}: TariffZonesResponse): TariffsZonesInfo {
  const countries: TariffsCountry[] = []
  const zones: TariffsZones = {}

  for (const {country_id: countryId, name, zones: allZones, main_zones: mainZones} of countriesWithZones) {
    const countryInfo = {id: countryId, title: name}

    countries.push(countryInfo)

    zones[countryId] = {
      allZones: allZones.map(toTariffsZone),
      mainZones: mainZones?.map(toTariffsZone),
    }
  }

  const defaultCountry =
    defaultCountryRepo && countries.some(({id}) => id === defaultCountryRepo)
      ? defaultCountryRepo
      : countries[0]?.id || raise('List of countries is empty')

  const getCurrentCountry = (countryId: string) =>
    countries.find(({id}) => id === countryId) || raise(`Wrong country id: ${countryId}`)

  const getCurrentZones = (countryId: string) => zones[countryId] || raise(`Wrong country id: ${countryId}`)

  const getCurrentCity = (countryId: string, cityId: string) =>
    getCurrentZones(countryId).allZones.find(({id}) => id === cityId) || raise(`Wrong city id: ${cityId}`)

  return {
    countries,
    zones,
    defaultCountry,
    getCurrentCountry,
    getCurrentZones,
    getCurrentCity,
    shouldAskCountry: !defaultCountryRepo,
  }
}

const toTariffsZone = ({name, id, default_point}: ZoneItem): TariffsZone => ({title: name, id, point: default_point})
